import { number, func, array } from 'prop-types'
import { CvsCarousel } from '@components'

export const NewValidationPicker = ({ validations = [], selected = -1, onSelect = () => {} }) => {
  return <CvsCarousel selectedItem={selected} onItemSelect={onSelect} items={validations} />
}

NewValidationPicker.propTypes = {
  validations: array,
  selected: number,
  onSelect: func,
}
